import { render, staticRenderFns } from "./DriverStats.vue?vue&type=template&id=1df1bdfa"
import script from "./DriverStats.vue?vue&type=script&lang=js"
export * from "./DriverStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports